import { useTranslation } from "react-i18next"
import ModalPortal from "../../components/Modal/ModalPortal"
import defaultStyle from "../../styles/defaultPageStyle.module.css"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"

export function RedirectPaymentModal() {
  const { t } = useTranslation()

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert1}>
            <div className="p-4 flex flex-col w-full">
              <div className="mx-auto h-14 w-14 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />

              <p className="mt-5 text-sm text-center font-black uppercase tracking-wider text-slate-900">
                {t("publicMenu:checkout.redirecting_online_payment_title")}
              </p>

              <p className="mt-2 text-sm text-center text-slate-600">
                {t("publicMenu:checkout.redirecting_online_payment_description")}
              </p>
            </div>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
